export const getGeneralModalError = (e) => {
  if (e.errors) {
    if (e.errors._error) {
      return e.errors._error;
    }

    let transformedError = e.errors;
    const keys = Object.keys(transformedError);
    keys.forEach((key) => {
      if (Array.isArray(transformedError[key])) {
        transformedError[key] = transformedError[key].join('; ');
      }
    });

    return transformedError;
  }

  return e;
};
